import { Box, Typography } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { dataTestIds } from 'src/constants/data-test-ids';
import { useChartFields } from '../../../hooks/useChartFields';

export const HistoryOfPresentIllnessContainer: FC = () => {
  const { data: chartFields } = useChartFields({
    requestedFields: {
      chiefComplaint: {
        _tag: 'chief-complaint',
      },
    },
  });
  const { t } = useTranslation();

  const historyOfPresentIllness = chartFields?.chiefComplaint?.text;

  return (
    <Box
      sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, width: '100%' }}
      data-testid={dataTestIds.progressNotePage.hpiContainer}
    >
      <Typography variant="h5" color="primary.dark">
        {t('telemed.review.hpi.title')}
      </Typography>
      <Typography>{historyOfPresentIllness}</Typography>
    </Box>
  );
};
